<template>
    <b-card
        :title="title"
        icon="mdiBankTransfer"
        @cancel="$emit('cancel')"
        @submit="
            mode == 1 ? updateGlobalLimits(dailyLimit) : updateLimit(dailyLimit)
        "
        :submit-text="{ el: 'Αποθήκευση', en: 'Save', it: 'Salva' }"
        :cancel-text="{ el: 'Ακύρωση', en: 'Cancel', it: 'Cancella' }"
    >
        <v-row class="pt-2" no-gutters v-for="cur of currencyOptions" :key="cur.value">
            <v-col cols="3" class="pr-1">
                <v-select
                    v-model="status"
                    :items="['Offline', 'Online']"
                    menu-props="offsetY"
                    color="secondary"
                    item-color="secondary"
                    outlined
                    dense
                    hide-details
                ></v-select>
            </v-col>
            <v-col cols="6" class="px-1">
                <v-text-field
                    :label="translations.dailyTransactionLimits[lang]"
                    v-model="dailyLimit[status.toLowerCase()][cur.key]"
                    color="secondary"
                    outlined
                    dense
                    clearable
                    hide-details
                ></v-text-field>
            </v-col>
            <v-col cols="3" class="pl-1">
                <div class="pt-2">{{cur.text == 'Amount'? '€' : cur.text}}</div>
                <!-- <v-select
                    v-model="currency"
                    :items="[cur]"
                    menu-props="offsetY"
                    color="secondary"
                    item-color="secondary"
                    outlined
                    dense
                    disabled
                    hide-details
                ></v-select> -->
            </v-col>
        </v-row>
    </b-card>
</template>

<script>
import { mdiBankTransfer } from "@mdi/js";
import { mapState, mapMutations, mapActions } from "vuex";
import translations from "@/utils/translations/loyaltyPanel/stores/dailyTransactionLimits";

export default {
    name: "LimitsForm",

    mixins: [translations],

    props: {
        mode: {
            type: Number,
        },
        updateStatus: {
            type: String,
        },
    },
    data: () => ({
        icons: { mdiBankTransfer },
        status: "Offline",
        currency: 1,
        globalOfflineAmountLimit: 0,
        globalOfflinePointsLimit: 0,
        globalOnlineAmountLimit: 0,
        globalOnlinePointsLimit: 0,
    }),

    mounted() {
        if (this.updateStatus == "offline") {
            this.status = "Offline";
        } else {
            this.status = "Online";
        }
    },

    watch: {
        updateStatus(val) {
            if (val == "offline") {
                this.status = "Offline";
            } else {
                this.status = "Online";
            }
        },
    },

    computed: {
        title() {
            return this.mode === 1
                ? this.translations.modalTitle1[this.lang]
                : this.translations.modalTitle2[this.lang] +
                      this.dailyLimit.app_name;
        },

        query() {
            let query = "?";

            for (let key in this.$route.query) {
                query += `${key}=${this.$route.query[key]}&`;
            }

            return query.slice(0, query.length - 1);
        },

        currencyOptions() {
            return [
                {
                    text: this.translations.amount[this.lang],
                    value: 1,
                    key: "amount"
                },
                {
                    text: this.translations.points[this.lang],
                    value: 2,
                    key: "points"
                },
            ];
        },

        lang() {
            return this.$route.params.lang;
        },

        dailyLimit: {
            get() {
                return this.$store.state.loyaltyPanel.stores.dailyLimits
                    .dailyLimit;
            },
            set(val) {
                this.setItem(val);
            },
        },

        limitModel: {
            get() {
                return this.status == "Offline"
                    ? this.currency == 1
                        ? this.dailyLimit.offline.amount
                        : this.dailyLimit.offline.points
                    : this.currency == 1
                    ? this.dailyLimit.online.amount
                    : this.dailyLimit.online.points;
            },
            set(val) {
                if (this.status == "Offline") {
                    if (this.currency == 1) {
                        this.dailyLimit.offline.amount = Number(val);
                    } else {
                        this.dailyLimit.offline.points = Number(val);
                    }
                } else {
                    if (this.currency == 1) {
                        this.dailyLimit.online.amount = Number(val);
                    } else {
                        this.dailyLimit.online.points = Number(val);
                    }
                }
            },
        },
    },

    methods: {
        ...mapActions("loyaltyPanel/stores/dailyLimits", [
            "updateLimit",
            "updateGlobalLimits",
        ]),
        ...mapMutations("loyaltyPanel/stores/dailyLimits", ["setItem"]),
    },
};
</script>
